import React, { useState } from "react";

import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

import axios from '@app/lib/axios';

import ModalSearch from "./ModalSearch";

class ModalUpdate extends React.Component {
  constructor(props) {
    super(props);
    const { selectedNursery } = this.props;
    this.state = {
      selectedNurseryUniq: null,
      mappedNurseries: null,
      showModalSearch: false,
      searchedNurseryApi: null,
      serviceTypeSelected: "N",
      serviceTypeSearched: "N",
      isRefineOk: selectedNursery.isRefined,
      isUpdateNecessary: false,
    };
  }

  componentDidMount = () => {
    this.getMappedNurseries();
  };

  getMappedNurseries = () => {
    const { selectedNursery } = this.props;
    axios({
      method: "GET",
      url: `/api/nursery/refine/info?id=${selectedNursery.id}&uniqId=${selectedNursery.uniqId}`,
    })
      .then((result) => {
        this.setState({
          mappedNurseries: result.data.mappedNurseries,
          selectedNurseryUniq: result.data.nurseryUniq,
          serviceTypeSelected: result.data.nurseryUniq
            ? result.data.nurseryUniq.serviceType
            : "N",
          isRefineOk: result.data.nurseryUniq
            ? result.data.nurseryUniq.isRefined
            : false,
        });
      })
      .catch((error) => {
        console.error(error);
        toast.error("원 정보를 요청하는 동안 에러가 발생하였습니다.");
      });
  };

  onUpdateExecute = (e) => {
    if (this.checkUpdateNecessary()) {
      const { selectedNursery } = this.props;
      const {
        selectedNurseryUniq,
        searchedNurseryApi,
        serviceTypeSelected,
        serviceTypeSearched,
        isRefineOk,
      } = this.state;
      var isNewUniq = (searchedNurseryApi && searchedNurseryApi.uniqId == null) ? true : (selectedNurseryUniq ? false : true); // 통합원에 연동된 원이 없거나 선택한 API 원이 통합 DB에 없는 경우
      var isUpdate = !searchedNurseryApi && selectedNursery.serviceType != serviceTypeSelected;
      var isUniqNotApi =
        !isNewUniq && !isUpdate && !selectedNurseryUniq.apiKey && !searchedNurseryApi.uniqId ? true : false; // 통합DB에 등록되어 있으나 API 매칭된 원이 없으며 검색한 원이 통합DB에 등록되지 않은 경우
      var confirmMsg = searchedNurseryApi
        ? (isNewUniq
          ? "선택된 원 정보로 통합 원에 등록하고 연동하시겠습니까?\n* 원장 이름(계정이름사용)/전화번호는 적용되지 않습니다."
          : (isUniqNotApi ? "선택한 공공 API 원 정보를 기존 통합 원 정보에 적용하시겠습니까?\n* 원장 이름(계정이름사용)/전화번호는 적용되지 않습니다." : "선택한 통합 원 ID로 변경하시겠습니까?"))
        : `수정된 정보를 통합 DB내 원 정보에 적용하시겠습니까?`;
      if (window.confirm(confirmMsg)) {
        var postData = {
          nurseryId: selectedNursery.id,
          directorUserId: selectedNursery.directorUserId,
          refineOk: isRefineOk,
        };
        if (selectedNurseryUniq) {
          postData["nurseryUniqId"] = selectedNurseryUniq.id;
        }
        if (searchedNurseryApi) {
          postData["nurserySearchedId"] = searchedNurseryApi.no;
          postData["nurserySearchedUniqId"] = searchedNurseryApi.uniqId;
          postData["nurserySearchedLocCode"] = searchedNurseryApi.locCode;
          postData["serviceTypeSearched"] = serviceTypeSearched;
          postData["nurseryUpdateToSearched"] = !isNewUniq && isUniqNotApi;
        }
        if (selectedNursery.serviceType != serviceTypeSelected) {
          postData["serviceTypeSelected"] = serviceTypeSelected;
        }

        axios({
          method: "POST",
          url: `/api/nursery/refine/update`,
          data: postData,
        })
          .then((response) => {
            if (response.data.code == 200) {
              const { onUpdate } = this.props;
              onUpdate(`원 공공정보 매칭여부를 수정하였습니다.`);
            } else {
              console.error(response.data);
              toast.error(response.data.msg);
            }
          })
          .catch((error) => {
            console.error(error);
            if (error && error.data && error.data.msg) {
              toast.error(error.data.msg);
            } else {
              toast.error("에러가 발생하였습니다.");
            }
          });
      }
    }
  };

  onCreateExecute = (e) => {
    const { selectedNursery } = this.props;
    const { selectedNurseryUniq, isRefineOk } = this.state;
    var confirmMsg = selectedNurseryUniq
      ? "연동된 통합 원 정보가 있습니다.\n선택한 원 정보로 통합 DB에 신규 등록하시겠습니까?"
      : `선택한 원 정보로 통합 DB에 신규 등록하시겠습니까?`;
    if (window.confirm(confirmMsg)) {
      var postData = {
        nurseryId: selectedNursery.id,
        directorUserId: selectedNursery.directorUserId,
        refineOk: isRefineOk,
      };

      axios({
        method: "POST",
        url: `/api/nursery/refine/create`,
        data: postData,
      })
        .then((response) => {
          const { onUpdate } = this.props;
          onUpdate(`통합 원 DB에 신규 등록하였습니다.`);
        })
        .catch((error) => {
          console.error(error);
          if (error && error.data && error.data.msg) {
            toast.error(error.data.msg);
          } else {
            toast.error("에러가 발생하였습니다.");
          }
        });
    }
  };

  handleClose = () => {
    const { onModalClose } = this.props;
    onModalClose();
  };

  onSearchSelected = (selectedApi) => {
    this.setState(
      { searchedNurseryApi: selectedApi, serviceTypeSearched: "N" },
      () => this.setState({ isUpdateNecessary: this.checkUpdateNecessary() })
    );
  };

  clearSearchedApi = () => {
    this.setState({ searchedNurseryApi: null }, () =>
      this.setState({ isUpdateNecessary: this.checkUpdateNecessary() })
    );
  };

  getLocName = (locCode) => {
    if (this.props.locCodes) {
      const locCodeParent = Math.floor(locCode / 1000);
      const locParent = this.props.locCodes.find(
        (l) => l.code === locCodeParent
      );
      if (locParent) {
        const locInfo = locParent.child.find((l) => l.code === locCode);
        if (locInfo) {
          return locInfo.parent_name_sigungu
            ? `${locInfo.parent_name_sido} ${locInfo.parent_name_sigungu}`
            : `${locInfo.parent_name_sido} ${locInfo.name}`;
        }
      }
    }
    return "-";
  };

  checkUpdateNecessary = () => {
    const { selectedNursery } = this.props;
    const {
      selectedNurseryUniq,
      searchedNurseryApi,
      serviceTypeSelected,
      isRefineOk,
    } = this.state;
    if (
      searchedNurseryApi ||
      selectedNursery.isRefined != isRefineOk ||
      (selectedNurseryUniq &&
        selectedNurseryUniq.serviceType != serviceTypeSelected)
    ) {
      return true;
    }
    return false;
  };

  handleServiceTypeChange = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;

    this.setState(
      {
        [name]: value,
      },
      () => this.setState({ isUpdateNecessary: this.checkUpdateNecessary() })
    );
  };

  onRefineChange = (e) => {
    this.setState({ isRefineOk: e.target.checked }, () =>
      this.setState({ isUpdateNecessary: this.checkUpdateNecessary() })
    );
  };

  render() {
    const { show, selectedNursery, locCodes } = this.props;
    const {
      selectedNurseryUniq,
      mappedNurseries,
      showModalSearch,
      searchedNurseryApi,
      serviceTypeSelected,
      serviceTypeSearched,
      isRefineOk,
      isUpdateNecessary,
    } = this.state;
    return (
      <Modal
        show={show}
        size="xl"
        onHide={this.handleClose}
        aria-labelledby="example-custom-modal-styling-title"
        className={showModalSearch ? "hidden" : ""}
      >
        <Modal.Body>
          <div className="row mb-0">
            <div className="text-left ml-3">
              <div className="h3">
                <span className="mr-1">통합 DB 원 정보 연동 - </span>
                <span className="mr-1">{`${selectedNursery.name}(${selectedNursery.id})`}</span>
              </div>
            </div>
          </div>
          <hr className="mt-0 mb-3" />
          <div className="w-100 mb-3">
            <div
              className={`card border-top border-3 border-top-primary pt-0 mb-0`}
            >
              <div className="card-body metric-value">
                <div className="row">
                  <div className="col-10 h5">통합 DB 원 정보</div>
                  <div className="col-2 text-right">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => this.setState({ showModalSearch: true })}
                    >
                      원 정보 찾기
                    </button>
                  </div>
                </div>
                <div className="w-100" style={{ overflowX: "scroll" }}>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">통합 원 ID</th>
                        <th scope="col">타입</th>
                        <th scope="col">CODE</th>
                        <th scope="col">원</th>
                        <th scope="col">원장</th>
                        <th scope="col">전화번호</th>
                        <th scope="col">주소</th>
                        <th scope="col">계약</th>
                        <th scope="col">API</th>
                        <th scope="col">비고</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedNurseryUniq && (
                        <tr>
                          <td>{selectedNurseryUniq.id}</td>
                          <td>
                            <select
                              className="form-control form-control-sm"
                              name="serviceTypeSelected"
                              value={serviceTypeSelected}
                              onChange={this.handleServiceTypeChange}
                            >
                              <option value="N">일반</option>
                              <option value="B">영업</option>
                              <option value="T">테스트</option>
                            </select>
                          </td>
                          <td>{selectedNurseryUniq.code}</td>
                          <td>{selectedNurseryUniq.name}</td>
                          <td>{selectedNurseryUniq.ceo}</td>
                          <td>{selectedNurseryUniq.tel}</td>
                          <td>{selectedNurseryUniq.address}</td>
                          <td>{selectedNurseryUniq.contractAp}</td>
                          <td>
                            {selectedNurseryUniq.apiKey ? (
                              <span class="text-success">연동</span>
                            ) : (
                              <span class="text-danger">미연동</span>
                            )}
                          </td>
                          <td>-</td>
                        </tr>
                      )}
                      {selectedNurseryUniq == null && (
                        <tr>
                          <td colSpan={11}>연동된 통합 원이 없습니다.</td>
                        </tr>
                      )}
                      {searchedNurseryApi && (
                        <tr className="bg-warning">
                          <td>
                            {searchedNurseryApi.uniqId
                              ? searchedNurseryApi.uniqId
                              : "신규"}
                          </td>
                          <td>
                            <select
                              className="form-control form-control-sm"
                              name="serviceTypeSearched"
                              value={serviceTypeSearched}
                              onChange={this.handleServiceTypeChange}
                            >
                              <option value="N">일반</option>
                              <option value="B">영업</option>
                              <option value="T">테스트</option>
                            </select>
                          </td>
                          <td>{searchedNurseryApi.code}</td>
                          <td>{searchedNurseryApi.name}</td>
                          <td>{searchedNurseryApi.ceo}</td>
                          <td>{searchedNurseryApi.tel}</td>
                          <td>{searchedNurseryApi.address}</td>
                          <td>{searchedNurseryApi.contractAp}</td>
                          <td>
                            {searchedNurseryApi.apiKey ? (
                              <span class="text-success">연동</span>
                            ) : (
                              <span class="text-danger">미연동</span>
                            )}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={this.clearSearchedApi}
                            >
                              취소
                            </button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100">
            <div
              className={`card border-top border-3 border-top-primary pt-0 mb-0`}
            >
              <div className="card-body metric-value">
                <div className={`stat-content card-stat-content-title h5`}>
                  연동된 TAS 원 목록
                  <span className="small text-primary ml-2">(* 토모노트/한글수/별별책방/플라잉 계약 수는 (승인된 계약 수)/(승인 대기 계약 수) 형태로 표시됩니다.) </span>
                </div>
                <div className="w-100" style={{ overflowX: "scroll" }}>
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">통합 원 ID</th>
                        <th scope="col">검수여부</th>
                        <th scope="col">계약지사</th>
                        <th scope="col">원장ID</th>
                        <th scope="col">원</th>
                        <th scope="col">원장</th>
                        <th scope="col">전화번호</th>
                        <th scope="col">주소</th>
                        <th scope="col">생성일</th>
                        <th scope="col">지역</th>
                        <th scope="col">반</th>
                        <th scope="col">토모노트</th>
                        <th scope="col">한글수</th>
                        <th scope="col">별별책방</th>
                        <th scope="col">플라잉</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mappedNurseries && mappedNurseries.length > 0 ? (
                        mappedNurseries.map((n) => (
                          <tr
                            className={`${
                              n.id == selectedNursery.id ? "bg-secondary" : ""
                            }`}
                          >
                            <td>{n.id}</td>
                            <td>{n.uniqId ? n.uniqId : "-"}</td>
                            <td>
                              {n.isRefined == "1" ? (
                                <span class="">완료</span>
                              ) : (
                                <span class="">미검수</span>
                              )}
                            </td>
                            <td>{n.branchName}</td>
                            <td>{n.directorUserId}</td>
                            <td>{n.nurseryName}</td>
                            <td>{n.directorName}</td>
                            <td>{n.tel}</td>
                            <td>{n.address}</td>
                            <td>{n.createDate}</td>
                            <td>{this.getLocName(n.locCode)}</td>
                            <td>{n.classCount}</td>
                            <td>{n.apNote}/{n.wtNote}</td>
                            <td>{n.apBooks}/{n.wtBooks}</td>
                            <td>{n.apEnglish}/{n.wtEnglish}</td>
                            <td>{n.apMomo}/{n.wtMomo}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={13}>연결된 원이 없습니다.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="modal-footer">
          <div class="form-check">
            <label
              className="form-check-label text-success pr-4"
              for="defaultCheck1"
            >
              * 통합 DB 정보와 TAS 원 정보간 검수 완료 여부:
            </label>
            <input
              className="form-check-input"
              type="checkbox"
              checked={isRefineOk}
              onChange={this.onRefineChange}
            />
          </div>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={this.handleClose}
          >
            취소
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.onUpdateExecute}
            disabled={!isUpdateNecessary}
          >
            적용
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={this.onCreateExecute}
          >
            신규
          </button>
        </div>
        {showModalSearch ? (
          <ModalSearch
            show={showModalSearch}
            setShow={() => this.setState({ showModalSearch: false })}
            locCodes={locCodes}
            selected={selectedNursery}
            onSearchSelected={this.onSearchSelected}
          />
        ) : (
          <></>
        )}
      </Modal>
    );
  }
}

export default ModalUpdate;
